import { ca } from '@cian/analytics';

export function trackMVKBlockAppearance() {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Card_JK',
    action: 'master_podbora_show_map',
    label: '',
    useLastProducts: true,
  });
}
